import React from 'react';

import Heading from 'components/reusable/authorization/Heading/Heading.layout';
import { Button } from 'components/reusable/Buttons/Button';
import ButtonsWrap from 'components/reusable/Buttons/ButtonsWrap.styled';

import { ConsentDeclinedProps } from './ConsentDeclined.types';

export default function ConsentDeclined(props: ConsentDeclinedProps) {
    const { t } = props;

    return (
        <main>
            <Heading
                pageHeader={t('consentDeclined.header')}
                iconName="closeCircle"
                iconColor="error.base"
                pageSubheader={t('consentDeclined.subHeader')}
            />

            <ButtonsWrap>
                <Button onClick={() => props.dispatchFinishWorkflow()} variant="error">{t('common:buttons.redirectBack.text')}</Button>
            </ButtonsWrap>
        </main>
    );
}
